import type { AvailabilityContext, AvailabilityState } from './types';

// Gating logic straight from the SHC "User States × Journey Phases" spec:
// - shopping/booking: renders for ANY auth state (incl. unauthenticated) when the
//   user has a stay at that property in their cart.
// - pre-arrival / stay: renders only for authenticated, persistent or partially
//   authenticated users with a stay at that property.
export function shouldShowAvailability(ctx?: AvailabilityContext): boolean {
	if (!ctx?.hasStayAtProperty) return false;
	switch (ctx.journeyPhase) {
		case 'shopping':
			return true;
		case 'pre-arrival':
		case 'stay':
			return ctx.userState !== 'unauthenticated';
		default:
			return false;
	}
}

export type AvailabilityTone = 'available' | 'limited' | 'unavailable';

// The three availability labels configured on the product card in Blacklight.
export function availabilityLabel(state: AvailabilityState): {
	label: string;
	tone: AvailabilityTone;
} {
	switch (state) {
		case 'available':
			return { label: 'Available for your dates', tone: 'available' };
		case 'some':
			return { label: 'Some dates available', tone: 'limited' };
		case 'none':
			return { label: 'Not available for your dates', tone: 'unavailable' };
	}
}
